import {
	OrthographicCamera,
	PerspectiveCamera,
	Scene,
	WebGLRenderer,
} from "three";

/**
 * Represents a scene capable of showing a gltf (and only gltf) formatted model.
 */
export class Web3dScene
{
	//	private static DEFAULT_CONFIG = new DefaultGltfSceneConfig();

	readonly renderer: WebGLRenderer;
	readonly camera: PerspectiveCamera|OrthographicCamera;
	readonly scene: Scene;

	/**
	 * Constructs a new GLTFScene using the specified parameters.
	 *
	 * @param container the HTML element supposed to contain the scene
	 * @param config an optional config specifying the look and behaviour of the scene
	 */
	constructor(renderer: WebGLRenderer, camera: PerspectiveCamera|OrthographicCamera, scene: Scene)
	{
		this.renderer = renderer;
		this.camera = camera;
		this.scene = scene;
	}
}
